window.UK_R1_MANUAL_DATA = {
  "manual": {
    "title": "R1 Wireless Remote Fob manual",
    "hero_title": "R1 Wireless Remote Fob",
    "product_family": "R1 Wireless Remote Fob",
    "primary_app": "TTLock",
    "manual_version": "V26.1",
    "lead": "Follow the illustrated R1 Wireless Remote Fob instructions, check each step and search this manual when you need help.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/app/ttlock/id1033046018"
    },
    "checklist": [
      "Open the selected lock in TTLock.",
      "Have your R1 remote to hand.",
      "Choose the remote’s name and validity period."
    ],
    "quick_specs": {
      "App": "TTLock",
      "Battery": "CR2032"
    },
    "search_placeholder": "Search steps, settings or a problem"
  },
  "guides": [
    {
      "handle": "r1-01",
      "title": "Buttons and indicator lights",
      "category": "Everyday use",
      "steps": [
        "Short-press the unlock button to unlock the paired lock; observe the status light flashing simultaneously.",
        "Short-press the lock button to lock the paired lock; observe the status light flashing simultaneously.",
        "Monitor the indicator light behavior during operation to identify normal or low battery status."
      ],
      "notes": [
        "Normal operation: The status light flashes simultaneously with each button press (unlock or lock).",
        "Low battery: The indicator light flashes slowly when unlocking or locking, signaling that the CR2032 battery needs replacement."
      ],
      "warnings": [],
      "common_mistakes": [],
      "summary": "Understand the functions of the unlock and lock buttons on the R1 wireless remote fob and interpret the indicator light status signals.",
      "expected_result": "The status light flashes with a short button press; slow flashing while locking or unlocking indicates low battery.",
      "images": [
        {
          "src": "uk-manual-r1-01-1.webp",
          "alt": "Buttons and indicator lights — Button & Indicator Light Status"
        }
      ]
    },
    {
      "handle": "r1-02",
      "title": "Pair with the lock",
      "category": "Pairing",
      "steps": [
        "Open the TTLock app on your smartphone and tap the lock you want to pair with the remote.",
        "Tap \"Remote\" in the lock management menu.",
        "Tap \"Add Remote\" to initiate the pairing wizard.",
        "Select the validity type (Timed / Permanent / Recurring), enter a name for the remote, then tap \"Next\".",
        "Tap \"R1\" from the device list.",
        "Long-press the locking key on the wireless remote fob until the red light flashes quickly, then release and tap \"Next\" in the app.",
        "Tap the \"+\" icon next to the displayed device name to confirm pairing.",
        "Check that pairing has succeeded, then test the lock and unlock buttons."
      ],
      "notes": [
        "The guide applies when your lock exposes the documented R1 Remote controls. If these are absent, contact support with the lock model."
      ],
      "warnings": [],
      "common_mistakes": [
        "Holding the unlock button instead of the locking key.",
        "Tapping Next before the red light flashes quickly."
      ],
      "summary": "Pair an R1 remote using the selected lock’s Remote menu in TTLock.",
      "expected_result": "The app displays \"Pairing succeeded\" and the remote fob can now lock and unlock the paired lock.",
      "images": [
        {
          "src": "uk-manual-r1-topic2-01_2x.png",
          "alt": "Select the lock to pair with R1."
        },
        {
          "src": "uk-manual-r1-topic2-02_2x.png",
          "alt": "Open Remote on the selected lock."
        },
        {
          "src": "uk-manual-r1-topic2-03_2x.png",
          "alt": "Tap Add Remote."
        },
        {
          "src": "uk-manual-r1-topic2-04_2x.png",
          "alt": "Choose Timed, Permanent or Recurring, enter a name, then tap Next."
        },
        {
          "src": "uk-manual-r1-topic2-05_2x.png",
          "alt": "Select R1."
        },
        {
          "src": "uk-manual-r1-topic2-06_2x.png",
          "alt": "Hold the locking key until the red light flashes quickly, release it, then tap Next."
        },
        {
          "src": "uk-manual-r1-topic2-07_2x.png",
          "alt": "Tap + next to the displayed R1."
        },
        {
          "src": "uk-manual-r1-topic2-08_2x.png",
          "alt": "Pairing succeeded; the remote appears in the list."
        }
      ]
    },
    {
      "handle": "r1-03",
      "title": "View remote information",
      "category": "Manage remotes",
      "steps": [
        "Open the selected lock’s Remote list in TTLock.",
        "Tap the target remote to view its battery level, validity period and records.",
        "Use the name and validity settings on that screen if you need to change them."
      ],
      "notes": [],
      "warnings": [],
      "common_mistakes": [],
      "summary": "Access detailed information about the paired R1 remote fob including battery level, usage records, and validity settings.",
      "expected_result": "The remote info page displays current battery status, access history, and allows configuration changes.",
      "images": [
        {
          "src": "uk-manual-r1-topic3-01_2x.png",
          "alt": "Select the target remote."
        },
        {
          "src": "uk-manual-r1-topic3-02_2x.png",
          "alt": "Remote information: battery, validity period and records."
        }
      ]
    },
    {
      "handle": "r1-04",
      "title": "Delete a remote fob",
      "category": "Manage remotes",
      "steps": [
        "Open the TTLock app and navigate to the paired lock's management page.",
        "Tap \"Remote\" to view the list of paired remote devices.",
        "Tap the wireless remote device you want to delete.",
        "Tap \"Delete\" at the bottom of the device detail page.",
        "Confirm the deletion when prompted by the app."
      ],
      "notes": [],
      "warnings": [],
      "common_mistakes": [
        "Selecting the wrong remote; check its name before deletion."
      ],
      "summary": "Remove a paired R1 wireless remote fob from the lock's authorized device list using the TTLock app.",
      "expected_result": "The selected remote is removed from the list.",
      "images": [
        {
          "src": "uk-manual-r1-topic4-01_2x.png",
          "alt": "Open Remote for the selected lock."
        },
        {
          "src": "uk-manual-r1-topic4-02_2x.png",
          "alt": "Select the remote you want to delete."
        },
        {
          "src": "uk-manual-r1-topic4-03_2x.png",
          "alt": "Tap Delete on the selected remote."
        },
        {
          "src": "uk-manual-r1-topic4-04_2x.png",
          "alt": "Confirm the deletion."
        }
      ]
    },
    {
      "handle": "r1-05",
      "title": "Replace the battery",
      "category": "Battery",
      "steps": [
        "Pry open the side seam between the two housing halves carefully using a thin tool.",
        "Lift out the PCBA (printed circuit board assembly) from the housing.",
        "Remove the depleted CR2032 battery from the PCBA battery holder.",
        "Insert a new CR2032 battery, following the polarity markings on the battery holder.",
        "Place the PCBA back into position inside the housing.",
        "Refit the housing halves together, ensuring the side seam is fully closed."
      ],
      "notes": [],
      "warnings": [
        "Use a CR2032 battery and follow the polarity markings on the battery holder."
      ],
      "common_mistakes": [
        "Installing the battery against the holder’s polarity markings."
      ],
      "summary": "Replace the CR2032 coin cell battery in the R1 wireless remote fob when the indicator shows low battery status.",
      "expected_result": "The circuit board is back in position and the housing is refitted.",
      "images": [
        {
          "src": "uk-manual-r1-topic5-01_2x.png",
          "alt": "Open the side seam between the housing halves."
        },
        {
          "src": "uk-manual-r1-topic5-02_2x.png",
          "alt": "Lift out the circuit board, replace its CR2032 battery and refit the housing."
        }
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "r1-pairing-help",
      "title": "Remote won’t pair",
      "category": "Pairing",
      "quick_checks": [
        "Select Remote → Add Remote on the intended lock.",
        "Choose the validity type and name, then select R1.",
        "Hold the locking key until red flashes quickly; release and tap Next."
      ],
      "fix_steps": [
        "Follow the pairing guide and tap + next to the displayed remote.",
        "If the controls differ or pairing fails, contact support with your lock model and the screen shown."
      ],
      "related_guides": [
        "r1-02"
      ]
    },
    {
      "handle": "r1-low-battery",
      "title": "Indicator flashes slowly",
      "category": "Battery",
      "explanation": "The R1 source describes slow flashing while locking or unlocking as low battery.",
      "quick_checks": [
        "Observe the light during a short lock or unlock press."
      ],
      "fix_steps": [
        "Follow the CR2032 replacement guide."
      ],
      "related_guides": [
        "r1-01",
        "r1-05"
      ]
    },
    {
      "handle": "r1-validity",
      "title": "Check a remote’s validity or records",
      "category": "Manage remotes",
      "quick_checks": [
        "Select the correct remote by its name."
      ],
      "fix_steps": [
        "Open its information page to review the validity period, battery and records."
      ],
      "related_guides": [
        "r1-03"
      ]
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Help pairing or using R1",
      "subject": "R1 Remote Fob — support request",
      "body": "Hi Blusafe team,\n\nOrder number: \nLock model: \nTTLock version: \nR1 name and validity type: \nIndicator pattern: \nStep or error shown: \n\nI have attached a screenshot of the relevant screen.\n\nThanks,\n[Your name]"
    }
  ],
  "support_email": "enquiries@blusafesolutions.co.uk",
  "search_index": [
    {
      "title": "Buttons and indicator lights",
      "type": "guide",
      "category": "Everyday use",
      "anchor": "r1-01",
      "summary": "Understand the functions of the unlock and lock buttons on the R1 wireless remote fob and interpret the indicator light status signals.",
      "keywords": "Short-press the unlock button to unlock the paired lock; observe the status light flashing simultaneously. Short-press the lock button to lock the paired lock; observe the status light flashing simultaneously. Monitor the indicator light behavior during operation to identify normal or low battery status. Normal operation: The status light flashes simultaneously with each button press (unlock or lock). Low battery: The indicator light flashes slowly when unlocking or locking, signaling that the CR2032 battery needs replacement."
    },
    {
      "title": "Pair with the lock",
      "type": "guide",
      "category": "Pairing",
      "anchor": "r1-02",
      "summary": "Pair an R1 remote using the selected lock’s Remote menu in TTLock.",
      "keywords": "Open the TTLock app on your smartphone and tap the lock you want to pair with the remote. Tap \"Remote\" in the lock management menu. Tap \"Add Remote\" to initiate the pairing wizard. Select the validity type (Timed / Permanent / Recurring), enter a name for the remote, then tap \"Next\". Tap \"R1\" from the device list. Long-press the locking key on the wireless remote fob until the red light flashes quickly, then release and tap \"Next\" in the app. Tap the \"+\" icon next to the displayed device name to confirm pairing. Check that pairing has succeeded, then test the lock and unlock buttons. The guide applies when your lock exposes the documented R1 Remote controls. If these are absent, contact support with the lock model."
    },
    {
      "title": "View remote information",
      "type": "guide",
      "category": "Manage remotes",
      "anchor": "r1-03",
      "summary": "Access detailed information about the paired R1 remote fob including battery level, usage records, and validity settings.",
      "keywords": "Open the selected lock’s Remote list in TTLock. Tap the target remote to view its battery level, validity period and records. Use the name and validity settings on that screen if you need to change them."
    },
    {
      "title": "Delete a remote fob",
      "type": "guide",
      "category": "Manage remotes",
      "anchor": "r1-04",
      "summary": "Remove a paired R1 wireless remote fob from the lock's authorized device list using the TTLock app.",
      "keywords": "Open the TTLock app and navigate to the paired lock's management page. Tap \"Remote\" to view the list of paired remote devices. Tap the wireless remote device you want to delete. Tap \"Delete\" at the bottom of the device detail page. Confirm the deletion when prompted by the app."
    },
    {
      "title": "Replace the battery",
      "type": "guide",
      "category": "Battery",
      "anchor": "r1-05",
      "summary": "Replace the CR2032 coin cell battery in the R1 wireless remote fob when the indicator shows low battery status.",
      "keywords": "Pry open the side seam between the two housing halves carefully using a thin tool. Lift out the PCBA (printed circuit board assembly) from the housing. Remove the depleted CR2032 battery from the PCBA battery holder. Insert a new CR2032 battery, following the polarity markings on the battery holder. Place the PCBA back into position inside the housing. Refit the housing halves together, ensuring the side seam is fully closed."
    },
    {
      "title": "Remote won’t pair",
      "type": "troubleshooting",
      "category": "Pairing",
      "anchor": "r1-pairing-help",
      "summary": "Remote won’t pair",
      "keywords": "Select Remote → Add Remote on the intended lock. Choose the validity type and name, then select R1. Hold the locking key until red flashes quickly; release and tap Next. Follow the pairing guide and tap + next to the displayed remote. If the controls differ or pairing fails, contact support with your lock model and the screen shown."
    },
    {
      "title": "Indicator flashes slowly",
      "type": "troubleshooting",
      "category": "Battery",
      "anchor": "r1-low-battery",
      "summary": "The R1 source describes slow flashing while locking or unlocking as low battery.",
      "keywords": "Observe the light during a short lock or unlock press. Follow the CR2032 replacement guide."
    },
    {
      "title": "Check a remote’s validity or records",
      "type": "troubleshooting",
      "category": "Manage remotes",
      "anchor": "r1-validity",
      "summary": "Check a remote’s validity or records",
      "keywords": "Select the correct remote by its name. Open its information page to review the validity period, battery and records."
    }
  ]
};
